import fetch from '../../../services/fetch';

const state = {
    admin:{
        dataCollection:{
            view:false
        },
        settings:{
            view:false
        }
    }
};

const getters = {
    admin : (state) => state.admin
};

const actions = {
    async getDataCollection ({commit,dispatch}){
        return fetch.post('/admin', {action:"get-admin-data"}).then(res=>res.data);
    }
};

const mutations = {
    setAdminView: (state,component) => {
        return Object.keys(state.admin).forEach(nav=>{
            if(nav === component){
                state.admin[nav].view = !state.admin[nav].view;
            }else{
                if(state.admin[nav].view)
                    state.admin[nav].view = false;
            }
        })
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}